/* eslint react/jsx-props-no-spreading: 0 */
/* eslint max-classes-per-file: 0 */
/* eslint-disable import/no-relative-packages */

import React from 'react';
import PropTypes from 'prop-types';
import {
  TouchableOpacity,
  View,
  Text,
  Dimensions,
} from 'react-native';
import ReactRouterPropTypes from 'react-router-prop-types';

import SideMenu from '../../../vendor/react-native-side-menu'; // eslint-disable-line
import ImageMenu from '../../assets/images/menu.svg';
import CustomMenu from './CustomMenu';

import AORTypes from '../../types';
import styles from '../../styles';
import infraConfig from '../../config.json';
// import Banner from '../misc/Banner';

class CustomSideMenu extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.toggle = this.toggle.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMenuItemSelected = this.onMenuItemSelected.bind(this);
    this.updateMenuState = this.updateMenuState.bind(this);

    this.state = {
      isSideMenuOpen: false,
      size: 0,
    };

    this.lastToggle = Date.now();
  }

  componentDidMount() {
    const { location, getAnalyticsService, childContainer } = this.props;

    if (!childContainer || !childContainer.comp) {
      console.log('no child component');
      return;
    }

    if (!getAnalyticsService) {
      console.log('no getAnalyticsService param');
      return;
    }

    if (!getAnalyticsService()) {
      console.log('no getAnalyticsService object');
      return;
    }

    if (!getAnalyticsService().report) {
      console.log('no getAnalyticsService report reference');
      return;
    }

    if (!getAnalyticsService().report.page) {
      console.log('no getAnalyticsService page function');
      return;
    }

    const child = childContainer.comp;
    // The production babel strips the class names.
    // A separate babel plugin injects 'displayName'.
    const title = child.displayName || child.constructor.name;
    getAnalyticsService().report.page(title, location.pathname);
    getAnalyticsService().report.event('page', 'nav', title, location.pathname);
  }

  componentWillUnmount() {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = undefined;
    }
  }

  // getDerivedStateFromProps respondes to the props changes: 'direction'
  static getDerivedStateFromProps(nextProps, prevState) {
    // Every time direction changes, make sure to close the menu
    if (nextProps.direction !== prevState.direction) {
      const size = CustomSideMenu.getResize(nextProps);

      return {
        direction: nextProps.direction,
        size,
      };
    }
    return {};
  }

  static getResize(props) {
    // console.log('getResize');

    const { direction } = props;

    // FIXME(clairbee): pass it from 'index' to avoid race condition
    const dims = Dimensions.get('window');
    // console.log('dims');
    // console.log(dims);
    // console.log(direction);
    // console.log(Platform.OS);
    const { width, height } = dims;
    let size = (direction === 'row') ? Math.max(width, height) / 2 : Math.min(width, height);

    size *= 0.8; // occupy 80% of the screen

    if (direction === 'column' && size > 800) {
      // on iPad even 'column' is wide enough to go for 40% instead of 80%
      size /= 2;
    }
    size = Math.floor(size);

    // console.log('size');
    // console.log(size);

    return size;
  }

  // onResize updates the state to reflect new window width
  onResize() {
    // console.log('onResize');

    // Maintain a pending request to avoid an avalanche of state changes when the browser window gets resized
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(() => {
      this.setState((_state, props) => {
        const size = CustomSideMenu.getResize(props);
        return { size };
      });
    }, 250);
  }

  onMenuItemSelected(item) {
    if (this.slidingPosition === undefined || this.slidingPosition < 0.9) {
      return;
    }

    this.setState({
      isSideMenuOpen: false,
    });

    const { history } = this.props;
    history.push(item);
  }

  // updateMenuState() is called by the side menu
  // to let us know that it's now open.
  // E.g. if the user pulled the side of the screen.
  updateMenuState(isOpen) {
    // console.log('updateMenuState');
    // console.log(isOpen);

    // if (Date.now() - this.lastToggle < 1000) {
    //   // Rate limit the toggle to 1 per second
    //   return;
    // }

    // FIXME(clairbee): do not call after componentWillUnmount
    const { isSideMenuOpen } = this.state;
    if (isOpen !== isSideMenuOpen) {
      this.setState({ isSideMenuOpen: isOpen });
    }
  }

  toggle() {
    // console.log('toggle');
    // console.log(this.state.isSideMenuOpen);
    if (Date.now() - this.lastToggle < 1000) {
      // Rate limit the toggle to 1 per second
      return;
    }
    // console.log('toggled');
    this.lastToggle = Date.now();

    this.setState((state, _props) => ({
      isSideMenuOpen: !state.isSideMenuOpen,
    }));
  }

  render() {
    const {
      children,
      direction,
      user,
      userData,
      getItems,
      location,
    } = this.props;
    const { isSideMenuOpen, size } = this.state;

    const menuComponent = (
      <>
        <CustomMenu
          key="menu"
          direction={direction}
          user={user}
          userData={userData}
          onItemSelected={this.onMenuItemSelected}
          getItems={getItems}
          location={location}
        />
        {infraConfig.envName !== 'prod' && (
          <Text
            key="envName"
            style={{
              alignSelf: 'center',
              padding: 10,
              backgroundColor: '#26272A',
              color: 'white',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {infraConfig.envName}
          </Text>
        )}
      </>
    );

    // TODO(clairbee): make sidebar width fluidly dependent on the screen width for wide screens
    // TODO(clairbee): make sidebar width fixed for non-wide screens
    return (
      <View
        style={{ flex: 1 }}
        onLayout={this.onResize}
      >
        <SideMenu
          key={user ? user.attributes.preferred_username : 'none'}
          style={styles.view.main}
          bounceBackOnOverdraw
          openMenuOffset={size}
          menu={menuComponent}
          isOpen={isSideMenuOpen}
          onChange={(isOpen) => this.updateMenuState(isOpen)}
          onSliding={(val) => {
            this.slidingPosition = val;
          }}
        >
          {/* {Platform.OS !== 'ios' && (
            <Banner text="beta" />
          )} */}

          <View style={{ flex: 1, backgroundColor: 'transparent' }}>
            <View style={styles.nav.background}>
              <View style={isSideMenuOpen ? styles.nav.outOfFocus : styles.nav.inFocus}>
                {children}
              </View>
            </View>
            <TouchableOpacity
              activeOpacity={0.2}
              focusedOpacity={0.7}
              style={{
                position: 'absolute',
                margin: 20,
                top: 0,
                left: 0,
              }}
              onPressOut={() => this.toggle()}
              hitSlop={{
                top: 10, left: 10, bottom: 10, right: 10,
              }}
            >
              <ImageMenu
                style={{
                  width: 24,
                  height: 24,
                }}
              />
            </TouchableOpacity>
          </View>
        </SideMenu>
      </View>
    );
  }
}

CustomSideMenu.defaultProps = {
  user: null,
  userData: null,
};

CustomSideMenu.propTypes = {
  direction: PropTypes.string.isRequired,
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User,
  getItems: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  childContainer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default CustomSideMenu;
